import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Stypi - the perfect blogging tool",
  "description": "",
  "published": "2012-01-03T00:00:00.000Z",
  "redirect_from": ["/blog/stypi-the-perfect-blogging-tool/swizec/3312"],
  "categories": "Business, Google, Google Wave, Linux, MacOS, Paul Graham, Startups, Stypi, Y Combinator",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Stypi is a collaborative text editing tool that came out of `}<a parentName="p" {...{
        "href": "http://www.ycombinator.com",
        "title": "Y Combinator"
      }}>{`YCombinator`}</a>{` a couple months ago. It's supposed to be filling a blank left behind `}<a parentName="p" {...{
        "href": "http://etherpad.com/",
        "title": "Etherpad test"
      }}>{`Etherpad`}</a>{` when it chewed up by Google and spat out as `}<a parentName="p" {...{
        "href": "http://wave.google.com/",
        "title": "Google Wave"
      }}>{`Wave`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/Screen-Shot-2012-01-03-at-4.25.36-PM-300x214.png",
        "alt": "This post in Stypi",
        "title": "This post in Stypi"
      }}></img></p>
    <p>{`Though I've never used Etherpad and have only seen `}<a parentName="p" {...{
        "href": "http://piratepad.net/",
        "title": "PiratePad"
      }}>{`Piratepad`}</a>{` once or twice I've come to rely on Stypi to produce blogposts.`}</p>
    <p>{`The first time I saw Stypi in action was when `}<a parentName="p" {...{
        "href": "http://paulgraham.com",
        "title": "Paul Graham (computer programmer)"
      }}>{`Paul Graham`}</a>{` posted a "Watch me write" on hackernews. It was a fascinating look into the way he writes because through Stypi's magic we got to watch a playback of one of his essays coming together.`}</p>
    <p>{`I remember being amazed by how often he typos not words, but whole paragraphs and started wondering how often I do something similar - off to Stypi! Been looking for a way to stop using Wordpress for content creation for a while anyway.`}</p>
    <p>{`At first I watched playbacks of my writing, but soon realised this was about as fun as watching a replay of your rally game - takes just as long, is super passive and kind of boring ... except in Stypi there aren't even any spectacular crashes!`}</p>
    <p>{`However, I've come to love Stypi for a different reason - it's the cleanest, most lightweight way to write. Nothing but me and my text.`}</p>
    <p>{`... and anybody who guesses the url I'm writing at ... One of the main selling points is collaborative editing, but I like to be alone when I write. Sorry Stypi :)`}</p>
    <p>{`Another big selling point for me is that it works `}{`_`}{`everywhere`}{`_`}{`. The only contender so far has been iA Writer, but that only works on `}<a parentName="p" {...{
        "href": "http://www.apple.com/macosx/",
        "title": "Mac OS"
      }}>{`MacOS`}</a>{` and costs money. But I really enjoy writing on my `}<a parentName="p" {...{
        "href": "http://www.kernel.org/",
        "title": "Linux"
      }}>{`Linux box`}</a>{` as well.`}</p>
    <p>{`All in all it's the perfect drafting tool that really encourages good drafting and rewriting principles. Especially because my better posts take about two or three rewrites before they're good enough.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://venturebeat.com/2011/09/26/stypi/"
        }}>{`Stypi founders have a plan to reinvent Google Wave (video)`}</a>{` (venturebeat.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://radar.oreilly.com/2011/11/four-short-links-10-november-2-2.html"
        }}>{`Four short links: 10 November 2011`}</a>{` (radar.oreilly.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/08/23/y-combinator-demo-day-the-ultimate-roundup/"
        }}>{`Y Combinator Demo Day (S11): The Ultimate Roundup`}</a>{` (techcrunch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/y-combinator-unveils-its-biggest-ever-batch-of-startups-63-companies-2011-8"
        }}>{`Silicon Alley Insider: Y Combinator Unveils Its Biggest-Ever Batch Of Startups: 63 Companies`}</a>{` (businessinsider.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://emkaytsg.wordpress.com/2011/10/30/cool-tools/"
        }}>{`Cool Tools`}</a>{` (emkaytsg.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://etherpad.org/2011/12/06/etherpad-international-hackathon-2012/"
        }}>{`Etherpad hackathon announced for early 2012`}</a>{` (etherpad.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b930305a-c73b-4500-9936-c43925223b20",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      